// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  GroupRunMode,
  GroupRunStatus,
} from "./types";


export default __t.row({
  groupRunId: __t.u64().primaryKey().name("group_run_id"),
  cohortAssignmentId: __t.u64().name("cohort_assignment_id"),
  projectId: __t.string().name("project_id"),
  name: __t.string(),
  sessionId: __t.u64().name("session_id"),
  leaderEmail: __t.string().name("leader_email"),
  get mode() {
    return GroupRunMode;
  },
  get status() {
    return GroupRunStatus;
  },
  currentStepId: __t.option(__t.string()).name("current_step_id"),
  currentPosition: __t.u32().name("current_position"),
  pausedByEmail: __t.option(__t.string()).name("paused_by_email"),
  createdByEmail: __t.string().name("created_by_email"),
  createdAt: __t.timestamp().name("created_at"),
  startedAt: __t.option(__t.timestamp()).name("started_at"),
  endedAt: __t.option(__t.timestamp()).name("ended_at"),
  allowLateJoin: __t.bool().name("allow_late_join"),
  autoStallSeconds: __t.u32().name("auto_stall_seconds"),
  stallFiresAt: __t.option(__t.timestamp()).name("stall_fires_at"),
});
